import BackupCodes from '@/components/mfa/mfa-backup-codes';
import Email2faAlert from '@/components/mfa/mfa-email-alert';
import EnableTotpFA from '@/components/mfa/mfa-totp-enable';
import { useAuthContext } from '@/context/auth-provider';
import { useEffect } from 'react';

const MFAHome = () => {
    const { refetch } = useAuthContext();
    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className='mb-8'>
            <div className='flex flex-col gap-2 mx-auto w-full md:max-w-5xl px-2 py-8'>
                <h1 className='text-fluid-h1 leading-[34px] tracking-[-0.416px] text-[#000509e3] dark:text-inherit font-extrabold'>
                    Setup Multi-Factor Authentication (MFA)
                </h1>
                <p className='text-sm text-muted-foreground font-normal'>
                    Protect your account by adding an extra layer of protection
                    against unauthorized access.
                </p>
            </div>

            <div className='relative  py-0 mx-auto sm:px-6 md:max-w-5xl'>
                <div className='steps-gradient dark:bg-gray-800 absolute top-0 h-full '></div>

                <Email2faAlert />

                <EnableTotpFA />

                <BackupCodes />
            </div>
        </div>
    );
};

export default MFAHome;
